var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinguisticSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2457 17C21.1685 17 11 29.6447 11 45.2457C11 55.6712 14.7855 64.7785 23.1997 69.6724L22.2987 76.8809L30.5071 72.5352C33.131 73.1589 36.0398 73.4914 39.2457 73.4914C59.0177 73.4914 67.4914 60.8439 67.4914 45.2457C67.4914 29.6474 57.3229 17 39.2457 17Z",
    fill: "#FFD100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7187 31.6581C47.7187 30.3868 48.7155 29.4207 50.0244 29.411C51.3332 29.4013 52.2239 30.491 52.2336 31.7999C52.2433 33.1088 51.3684 34.1438 50.0596 34.1536C48.7507 34.1633 47.7284 32.967 47.7187 31.6581Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.205 31.1312C56.2046 30.1603 56.926 29.4228 57.8737 29.4157C58.8213 29.4087 59.4664 30.2412 59.4739 31.2408C59.4813 32.2404 58.8482 33.0306 57.9006 33.0377C56.9529 33.0447 56.2124 32.1308 56.205 31.1312Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1846 37.4069C57.1895 35.6678 56.3984 34.2581 55.4115 34.2536C54.4246 34.249 53.6214 35.6553 53.6165 37.3944C53.6116 39.1335 54.4027 40.5432 55.3896 40.5477C56.3766 40.5522 57.1797 39.146 57.1846 37.4069Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7505 29.4104L78.174 22.0522",
    stroke: "#FF9539",
    strokeWidth: 3.38948,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8803 36.1505H82.065",
    stroke: "#FF9539",
    strokeWidth: 3.38948,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8803 43.4441L80.2156 49.6044",
    stroke: "#FF9539",
    strokeWidth: 3.38948,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinguisticSkills);
export default __webpack_public_path__ + "static/media/linguistic_skills.6b5fa94f81a14b4fe6d15e4d471505da.svg";
export { ForwardRef as ReactComponent };